export const ActionTypes = {
	SET_PRODUCTS: 'SET_PRODUCTS',
	SELECTED_PRODUCT: 'SELCTED_PRODUCT',
	REMOVE_SELECTED_PRODUCT: 'REMOVE_SELECTED_PRODUCT',
	FILTER_BY_CATEGORIES: 'FILTER_BY_CATEGORIES',
	SET_PRODUCT_HEADER: 'SET_PRODUCT_HEADER',
	REMOVE_PRODUCT_HEADER: 'REMOVE_PRODUCT_HEADER',
	SET_REVIEW: 'SET_REVIEW',
	FILTER_TRENDING: 'FILTER_TRENDING',
	USER_SELECTED_PRODUCTS: 'USER_SELECTED_PRODUCTS',
}
